// removed by extract-text-webpack-plugin
module.exports = {"base":"Paginator_base--2OoVQ","control":"Paginator_control--1XMmw","isDisabled":"Paginator_isDisabled--3-kFq","control__prev":"Paginator_control__prev--1DC6n","controlPrev":"Paginator_control__prev--1DC6n","control__next":"Paginator_control__next--1C1Ma","controlNext":"Paginator_control__next--1C1Ma","current":"Paginator_current--1d2Pt","divider":"Paginator_divider--b8SDs","total":"Paginator_total--2kAtl"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-wot-bootstrap/lib/components/Paginator/Paginator.css
// module id = 1806
// module chunks = 16